import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export default function registerFinanceiro(): void {

  const modules = [
    {
      entry: 'folha-pagamento',
      id: 'folha-pagamento',
      name: 'stipulator.folha-pagamento',
      route: APPLICATION_ROUTES.FOLHAS_PAGAMENTO,
      closeable: true,
    }, {
      entry: 'mensalidades',
      id: 'mensalidades',
      name: 'stipulator.mensalidades',
      route: APPLICATION_ROUTES.MENSALIDADES,
      closeable: true,
    }, {
      entry: 'faturas',
      id: 'faturas',
      name: 'stipulator.faturas',
      route: APPLICATION_ROUTES.FATURAS,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'financeiro',
    id: 'financeiro',
    name: 'stipulator.financeiro',
    modules,
    order: 4,
    closeable: true,
  });
}
